module.exports = __webpack_public_path__ + "static/Choco-0e30031e2f4b2d8c176df61a2731fb08.jpg";